module.exports = __webpack_public_path__ + "img/chrome_manage_cert.6b84f91c.png";